import React from 'react';
import { Link } from 'react-router-dom';
import { Quote, Star } from 'lucide-react';
export function HomeReviews() {
  return <section className="py-24 bg-off-white" data-id="element-1759">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1760">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1761">
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-1762">
            Trusted by Local Families
          </h2>
          <p className="text-xl font-bold text-ink" data-id="element-1763">
            <span className="text-gold tracking-wider" data-id="element-1764">★★★★★</span>{' '}
            <span className="text-subtle-gray mx-2" data-id="element-1765">|</span> 5.0 Rating From 201
            Reviews
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-1766">
          {[{
          quote: 'My kids love coming to class.',
          copy: 'Families mention that kids enjoy class, want to keep learning, and feel proud of their progress.'
        }, {
          quote: 'The coaches are structured and encouraging.',
          copy: 'Parents appreciate the positive coaching environment, clear expectations, and professional instruction.'
        }, {
          quote: "We've seen more confidence and focus.",
          copy: 'Reviews mention confidence, discipline, focus, respect, fitness, and growth outside of class.'
        }].map((review, idx) => <div key={idx} className="bg-paper p-8 rounded-2xl shadow-soft border border-subtle-gray relative flex flex-col" data-id="element-1767">
              <Quote className="absolute top-8 right-8 w-12 h-12 text-subtle-gray opacity-50" data-id="element-1768" />
              <div className="flex gap-1 text-gold mb-6" data-id="element-1769">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5" fill="currentColor" data-id="element-1770" />)}
              </div>
              <p className="text-xl text-ink font-bold mb-4 relative z-10 leading-snug" data-id="element-1771">
                &ldquo;{review.quote}&rdquo;
              </p>
              <p className="text-gray-warm leading-relaxed mb-6 flex-grow" data-id="element-1772">
                {review.copy}
              </p>
              <p className="text-sm text-storm-red font-bold uppercase tracking-wide" data-id="element-1773">
                Storm Parent
              </p>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-1774">
          <Link to="/Testimonials.html" className="btn-primary" data-id="element-1775">
            View More Reviews
          </Link>
        </div>
      </div>
    </section>;
}